import { render, staticRenderFns } from "./CalendarBlock.vue?vue&type=template&id=103fb54c"
import script from "./CalendarBlock.vue?vue&type=script&lang=ts"
export * from "./CalendarBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports